export default __webpack_public_path__ + "static/caseStudy2-uk-08f50476bcf58f09abccd98e19f767ff.webp";